import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../environments/environment';
import { AppStateService } from './app-state.service';
import { getApiHeaders } from './utils/api-headers.util';

interface ConfigResponse {
  orgTenantId?: string;  // Mark as optional to prevent issues if missing
  [key: string]: any; // Allow other properties
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private confUrl = environment.confUrl; // Use the configuration URL from environment.staging.ts
  private configData: any = null;  // Store the configuration data directly

  constructor(
    private http: HttpClient,
    private appStateService: AppStateService,
  ) {}


  private getHeaders() {
    return getApiHeaders();
  }

  // Load the configuration from the JSON file and store it
  loadConfig(tenantId: string): Observable<ConfigResponse> {
    const appConfigUrl = `${this.confUrl}/app_config/${tenantId}`;
    return this.http.get<ConfigResponse>(appConfigUrl, {
      headers: this.getHeaders()
    })
    .pipe(
      tap(config => this.configData = config), // Store the fetched config
      tap(config => {
        if (config.orgTenantId) {
          //store the orgTenantId in app state service
          this.appStateService.setState({
            orgTenantId: config.orgTenantId
          });
        }
      })
    );
  }

  // Provide access to the stored configuration data
  getConfigData(): any {
    return this.configData || {};
  }
}
